module.exports = __webpack_public_path__ + "static/media/tick.f75ef2e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ToolTip/tick.png
// module id = 2419
// module chunks = 0